import React from 'react';

import VirtualDynamicField from './VirtualDynamicField';
import { useFormSelector } from '../../custom-hooks';
import { getRootElements } from '../selectors/form-manager.selectors';
import { equalityFn } from '../utils/form-manager.utils';

/**
 * Builds the entire form layout without rendering any html element
 * Allows to track the state of the controls, which are inside collapsed subgrids or non-active tabs
 */
const VirtualFormManager = ({ isDetail = false }) => {
  const rootElements = useFormSelector(getRootElements, {}, equalityFn);

  return (
    <div id="virtual-form-manager">
      {rootElements &&
        Object.keys(rootElements).map((key) => (
          <VirtualDynamicField key={rootElements[key]} id={rootElements[key]} isDetail={isDetail} />
        ))}
    </div>
  );
};

export default VirtualFormManager;
